var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 21.75H15.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.75V13.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5L12 13.5L15 10.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37847 15.6574C6.48667 14.9608 5.76435 14.0712 5.26581 13.0554C4.76727 12.0396 4.50548 10.9239 4.50011 9.79237C4.47765 5.72715 7.755 2.34783 11.8192 2.25217C13.394 2.21425 14.9409 2.67317 16.2402 3.56384C17.5396 4.45451 18.5256 5.73169 19.0582 7.21424C19.5909 8.69678 19.6432 10.3094 19.2078 11.8234C18.7724 13.3373 17.8713 14.6758 16.6324 15.6488C16.3596 15.8602 16.1383 16.1309 15.9854 16.4404C15.8326 16.7499 15.7521 17.0901 15.75 17.4353L15.75 18.0001C15.75 18.199 15.671 18.3897 15.5303 18.5304C15.3897 18.671 15.1989 18.75 15 18.75H8.99998C8.80107 18.75 8.61031 18.671 8.46966 18.5304C8.32901 18.3897 8.24999 18.199 8.24998 18.0001L8.24998 17.4346C8.24912 17.0917 8.17021 16.7534 8.01921 16.4455C7.86821 16.1376 7.6491 15.868 7.37847 15.6574V15.6574Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBulb);
export default __webpack_public_path__ + "static/media/icon-bulb.973cf7763d768ef2aece053360b8842c.svg";
export { ForwardRef as ReactComponent };